import { c as create_ssr_component, b as add_attribute, v as validate_component } from "../../../chunks/ssr.js";
import { L as Limiter } from "../../../chunks/Limiter.js";
import { P as PrimaryButton } from "../../../chunks/PrimaryButton.js";
import { I as Input } from "../../../chunks/Input.js";
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let bio;
  let { form } = $$props;
  let { data } = $$props;
  if ($$props.form === void 0 && $$bindings.form && form !== void 0)
    $$bindings.form(form);
  if ($$props.data === void 0 && $$bindings.data && data !== void 0)
    $$bindings.data(data);
  bio = data.bio;
  return `${$$result.head += `<!-- HEAD_svelte-18hxmpw_START -->${$$result.title = `<title>Sign in</title>`, ""}<link rel="icon" type="image/png" sizes="300x300"${add_attribute("href", bio.avatar, 0)}><link rel="apple-touch-icon" sizes="300x300"${add_attribute("href", bio.avatar, 0)}><!-- HEAD_svelte-18hxmpw_END -->`, ""} ${validate_component(Limiter, "Limiter").$$render($$result, {}, {}, {
    default: () => {
      return `${form?.incorrect ? `<p class="p-4 bg-red-100 text-red-600 my-4 rounded-md" data-svelte-h="svelte-8gqmvc">Password incorrect. Please try again.</p>` : ``} <div class="w-full flex flex-col space-y-4 mt-12 mb-4"><form method="POST" class="flex flex-col space-y-8"><div class="flex flex-col"><label for="password" class="font-semibold mb-2 text-1xl" data-svelte-h="svelte-5c53l6">Enter your password</label> ${validate_component(Input, "Input").$$render(
        $$result,
        {
          type: "password",
          name: "password",
          id: "password"
        },
        {},
        {}
      )}</div> ${validate_component(PrimaryButton, "PrimaryButton").$$render($$result, { type: "submit" }, {}, {
        default: () => {
          return `Sign in`;
        }
      })} <div data-svelte-h="svelte-grxoj5"><a class="underline" href="/">Return to the homepage</a></div></form></div>`;
    }
  })}`;
});
export {
  Page as default
};
